import AdminMenu from './AdminMenu';
import AdminRecommendedPostAdd from './recommended-posts/AdminRecommendedPostAdd';

export default function AdminRecommendPost() {
    return (
        <>
            <AdminMenu />
            <div className="redesign-form-card redesign-form-card--narrow">
                <AdminRecommendedPostAdd />
            </div>
        </>
    )
}